import { Link } from 'react-router-dom';
import type { Comic } from '@/mocks/comics';

interface ComicCardProps {
  comic: Comic;
}

export default function ComicCard({ comic }: ComicCardProps) {
  return (
    <Link
      to={`/comic/${comic.id}`}
      className="group block rounded-lg overflow-hidden bg-background-50 border border-background-200/70 transition-all duration-300 hover:border-primary-300 cursor-pointer"
      data-product-shop=""
    >
      <div className="relative aspect-[5/7] overflow-hidden">
        <img
          src={comic.coverImage}
          alt={comic.title}
          title={`${comic.title} - 虚空韩漫网`}
          className="w-full h-full object-cover object-top transition-transform duration-500 group-hover:scale-105"
        />
        <div className="absolute top-2 left-2">
          <span
            className={`text-xs px-2 py-0.5 rounded-full font-medium whitespace-nowrap ${
              comic.status === '连载中'
                ? 'bg-primary-500 text-background-50'
                : 'bg-foreground-500 text-background-50'
            }`}
          >
            {comic.status}
          </span>
        </div>
        <div className="absolute bottom-0 left-0 right-0 bg-gradient-to-t from-black/70 to-transparent p-3">
          <div className="flex items-center gap-1 text-background-50 text-xs">
            <i className="ri-star-fill text-accent-500 text-xs"></i>
            <span>{comic.rating}</span>
          </div>
        </div>
      </div>

      <div className="p-3">
        <h3 className="text-sm font-heading font-bold text-foreground-900 truncate group-hover:text-primary-500 transition-colors">
          {comic.title}
        </h3>
        <p className="text-xs text-foreground-500 mt-1 truncate">{comic.author}</p>
        <div className="flex items-center gap-3 mt-2 text-xs text-foreground-400">
          <span className="flex items-center gap-1 whitespace-nowrap">
            <i className="ri-eye-line"></i>
            {comic.viewCount > 10000
              ? `${(comic.viewCount / 10000).toFixed(1)}万`
              : comic.viewCount}
          </span>
          <span className="flex items-center gap-1 whitespace-nowrap">
            <i className="ri-heart-line"></i>
            {comic.likeCount > 10000
              ? `${(comic.likeCount / 10000).toFixed(1)}万`
              : comic.likeCount}
          </span>
        </div>
        <div className="flex flex-wrap gap-1 mt-2">
          {comic.tags.slice(0, 3).map((tag) => (
            <span
              key={tag}
              className="text-xs px-1.5 py-0.5 rounded bg-background-100 text-foreground-500 whitespace-nowrap"
            >
              {tag}
            </span>
          ))}
        </div>
      </div>
    </Link>
  );
}